<template>
	<div class="header">
        <h1 class="op-clear">
            <router-link :to="{path: '/'}">
                <img class="logo-img" src="../../../static/images/logo.png" alt="">
            </router-link>
        </h1>
        <div class="nav op-clear">
            <ul>
                <li><router-link :to="{path: '/downloadmobile'}">移动浏览器</router-link></li>
                <li><router-link :to="{path: '/aboutus'}">关于我们</router-link></li>
                <li><router-link :to="{path: '/corporateculture'}">企业文化</router-link></li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Header',
	data() {
		return {}
	},
	computed: {}
}
</script>

<style scoped>
.header {
	display: flex;
	align-items: center;
    height: 0.8rem;
    line-height: 0.8rem;	
}

.header h1 {
    height: 0.8rem;
    line-height: 0.8rem;
    margin-left: 0.15rem;
	color: #fff;
}

.header h1 .logo-img {
    width: 1rem;
}
.nav ul{
    display: flex;
}
.nav ul li {
    height: 0.8rem;
    line-height: 0.7rem;
    font-size: 0.13rem;
    font-weight: 400;
    letter-spacing: 0px;
    padding: 0 0.15rem;
    color: rgba(0, 0, 0, 1);
}
a {
    color: rgba(0, 0, 0, 1);
}
</style>


// WEBPACK FOOTER //
// src/components/modules/Header.vue